"use client";

import React, { useEffect, useState } from "react";
import { getSavedStation, saveStation } from "../utils/printingStation";

const stations = Array.from({ length: 25 }, (_, i) => ({
  label: `Estación ${i + 1}`,
  value: String(i + 1),
}));

type Props = {
  className?: string;
  onChange?: (value: string | null) => void;
};

const SelectStation: React.FC<Props> = ({ className = "", onChange }) => {
  const [value, setValue] = useState<string>(stations[0].value);

  useEffect(() => {
    const stored = getSavedStation();
    if (stored) {
      setValue(stored);
      onChange?.(stored);
    } else {
      const def = stations[0].value;
      saveStation(def);
      setValue(def);
      onChange?.(def);
    }
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const v = e.target.value.trim();
    setValue(v);
    if (!v) {
      onChange?.(null);
    } else {
      saveStation(v);
      onChange?.(v);
    }
  };

  return (
    <div>
      <label htmlFor="station" className="block text-sm font-medium text-gray-700 py-2">
        Seleccionar estación de impresión
      </label>
      <select
        name="station"
        id="station"
        value={value}
        onChange={handleChange}
        className={`w-80 bg-white border-2 border-gray-300 text-gray-800 rounded-xl px-3 py-2 
                    focus:bg-blue-50 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 
                    outline-none transition-all duration-300 ${className}`}
        aria-label="Seleccionar estación de impresión"
      >
        {stations.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SelectStation;